import RCTEventEmitter from 'react-native-web/dist/vendor/react-native/emitter/EventEmitter';
import RCTDeviceEventEmitter from 'react-native-web/dist/vendor/react-native/NativeEventEmitter/RCTDeviceEventEmitter';

export { RCTEventEmitter, RCTDeviceEventEmitter };
